import { Component } from '@angular/core';

import { DeliveryModeEnum } from '@camelot/services';
import { TranslatePipe } from '@camelot/translation';

import { CamTranslationCore } from '../../../../../translation.service';
import { AbstractCellComponent } from '../../abstract';

export const deliveryModeLabel = (deliveryMode: number) =>
  `core.delivery-mode.${DeliveryModeEnum[deliveryMode]?.toLowerCase() ?? 'unknown'}`;

@Component({
  host: { 'data-cid': 'grid-delivery-mode-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [TranslatePipe],
  template: `
    @if (this.value !== null) {
      {{ this.deliveryModeLabel(this.value) | translate }}
    }
  `,
})
export class GridDeliveryModeCellComponent extends AbstractCellComponent<any, number> {
  public deliveryModeLabel = deliveryModeLabel;

  constructor() {
    super();
    CamTranslationCore.getInstance();
  }
}
